/**
 * Network status adapter (R1.2a).
 * - NATIVE: Capacitor Network plugin
 * - WEB: navigator.onLine + online/offline events
 */

import { isNative } from './isNative';
import { Network } from '@capacitor/network';

export async function getIsOnline(): Promise<boolean> {
  if (isNative()) {
    const status = await Network.getStatus();
    return status.connected;
  }
  return navigator.onLine;
}

export function addNetworkListener(callback: (online: boolean) => void): () => void {
  if (isNative()) {
    const handle = Network.addListener('networkStatusChange', (status) => {
      callback(status.connected);
    });
    return () => { handle.then(h => h.remove()); };
  }
  const onOnline = () => callback(true);
  const onOffline = () => callback(false);
  window.addEventListener('online', onOnline);
  window.addEventListener('offline', onOffline);
  return () => {
    window.removeEventListener('online', onOnline);
    window.removeEventListener('offline', onOffline);
  };
}
